<!--
 * @Author: your name
 * @Date: 2019-12-15 12:54:44
 * @LastEditTime: 2020-03-18 22:35:40
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \周记 张经伟e:\gi劳务\src\component\NavBar.vue
 -->
<template>
    <div id="navbar">
        <div v-if="!show">
            <van-nav-bar  :title="title" left-arrow @click-left="onClickLeft" :border="false"/>
        </div>
        <div v-else>
            <van-nav-bar  :title="title" @click-left="onClickLeft" :border="false"/>
        </div>
        
    </div>
</template>
<script>
export default {
    name: '',
    data() {
       return {
           timer: null,
       }
    },
    methods: {
        /**
         * 导航左边点击按钮
         */
        onClickLeft() {
            this.$router.go(-1);
        }
    },
    props: {
        title:  {
            type: String,
            required: true,
        },
        color: {
            type: String,
            required:true,
        },
        show: {
            type: Boolean
        }
    },
    mounted() {
        if(!this.show) {
            this.timer = setInterval(()=> {
                document.getElementsByClassName('van-nav-bar__title').length > 0 &&( document.getElementsByClassName('van-nav-bar__title')[0].style.color = this.color);
                document.getElementsByClassName('van-icon-arrow-left').length > 0 && (document.getElementsByClassName('van-icon-arrow-left')[0].style.color = this.color);
            },0)
        }
    },
    beforeDestroy() {
        if(!this.show) {
            clearInterval(this.timer);
        }
    },
}
</script>
<style scoped>
.van-nav-bar__left {
  bottom: auto;
}
.van-nav-bar {
  align-items: center;
  display: flex;
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/component/NavBar.vue